// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"43603acd","239":"4b600501","435":"f9b1fbc0","453":"45ae10fa","455":"1fe93b1b","635":"460d53b6","777":"6626ea3d","977":"9032279d"}[chunkId] + ".chunk.js";
};